module.exports = __webpack_public_path__ + "img/NI.b5277a7b.svg";